import React from 'react';
const AddToCartButton = React.memo(({ buttonText, extraClass, triggerAddToCartModal }) => {
    return (React.createElement("div", { className: `th-c-add-to-cart ${extraClass}` },
        React.createElement("button", { className: "button button--xl", onClick: triggerAddToCartModal }, buttonText)));
});
export default AddToCartButton;
